import { mapEnumToOptions } from '@abp/ng.core';

export enum DashboardPeriod {
  Monthly = 1,
  Yearly = 2,
}

export const dashboardPeriodOptions = mapEnumToOptions(DashboardPeriod);
